import React, { useState, useEffect, useCallback } from "react";
import { useStepNavigate } from "../hooks/useStepNavigate";
import { useOrder } from "../context/OrderContext";
import TablerLayout from "../components/layout/TablerLayout";
import StepperNavButton from "../components/stepper/StepperNavButton";
import Modal from "../components/modals/Modal";
import { IconAlertSmall, IconCamera, IconPhoto, IconUpload, IconFile, IconX, IconAlertTriangle } from "@tabler/icons-react";
import { dataService } from "../services/dataService";
import { useDropzone } from 'react-dropzone';

const EgyediKerdes = () => {
    const { order, updateOrder } = useOrder();
    const [formData, setFormData] = useState({
        veny_indvdl_permit_nr: "",
        veny_indvdl_permit_file: 1,
        veny_indvdl_permit_file_data: null,
        veny_indvdl_permit_file_url: null,
    });
    const [showModal, setShowModal] = useState(false);
    const [uploadLoading, setUploadLoading] = useState(false);
    const [showImageOptions, setShowImageOptions] = useState(false);
    const navigate = useStepNavigate();
    const [isMobile, setIsMobile] = useState(false);
    
    const [errorModal, setErrorModal] = useState({
        show: false,
        title: "",
        message: ""
    });

    useEffect(() => {
        const checkMobile = () => {
            const ua = navigator.userAgent;
            const isMobileDevice = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(ua);
            console.log('Eszköz detektálás:', isMobileDevice ? 'Mobil' : 'Desktop');
            setIsMobile(isMobileDevice);
        };
        checkMobile();
        window.addEventListener('resize', checkMobile);
        return () => window.removeEventListener('resize', checkMobile);
    }, []);

    const updateAktualisVeny = (ujAdatok) => {
        updateOrder((prev) => {
            const venyek = [...prev.venyek];
            venyek[prev.aktivVenyIndex] = { ...venyek[prev.aktivVenyIndex], ...ujAdatok };
            return { ...prev, venyek };
        });
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        let newValue = value;
        if (name === "veny_indvdl_permit_nr") {
            newValue = value.replace(/\s+/g, "").slice(0, 10);
        }
        setFormData({
            ...formData,
            [name]: newValue,
        });
    };

    const [deleteFileModal, setDeleteFileModal] = useState({
        show: false,
        loading: false
    });

    const convertToBase64 = (file) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = error => reject(error);
        });
    };

    const uploadImageToAPI = async (file) => {
        try {
            console.log("File feltöltés indult");
            
            
            
            
            const base64 = await convertToBase64(file);
            const base64Data = base64.split(',')[1];

            const imageData = {
                hmeliorder_szam: order.hmeliorder?.hmeliorder_szam,
                veny_szam: order.venyek[order.aktivVenyIndex]?.veny_szam || 1,
                image: base64Data,
                file_name: file.name,
                content_type: file.type,
                attachment_type: 'egyedi_kerelem',
            };

            const response = await dataService.uploadImage(imageData);
            
            if (response.data?.status === 'ok') {
                console.log("Kép sikeresen feltöltve:", response.data);
                return response.data.data;
            } else {
                throw new Error(response.data?.message || 'Képfeltöltési hiba');
            }
        } catch (error) {
            console.error('Képfeltöltési hiba:', error);
            setErrorModal({
                show: true,
                title: "Feltöltési hiba",
                message: `Hiba történt a kép feltöltésekor, kérem, próbálja meg újra! <br /> ${error.message}`
            });
            return null;
        } finally {
        
        
        }
    };

    const processFile = async (file) => {
        if (!file) return;
        
        const validTypes = ['image/jpeg', 'image/png', 'image/jpg', 'application/pdf'];
        if (!validTypes.includes(file.type)) {
            setErrorModal({
                show: true,
                title: "Nem támogatott fájlformátum",
                message: "Csak JPG, PNG vagy PDF fájl tölthető fel!"
            });
            return;
        }
        
        const maxSize = 5 * 1024 * 1024; // 5MB
        if (file.size > maxSize) {
            setErrorModal({
                show: true,
                title: "Túl nagy fájlméret",
                message: "A fájl mérete nem lehet nagyobb 5MB-nál!"
            });
            return;
        }
        
        try {
            if (formData.veny_indvdl_permit_file_data?.originalFile) {
                try {
                    URL.revokeObjectURL(URL.createObjectURL(formData.veny_indvdl_permit_file_data.originalFile));
                } catch (e) {
                    console.log('Előző blob felszabadítási hiba:', e);
                }
            }
            
            const response = await uploadImageToAPI(file);
            
            if (response) {
                setFormData({
                    ...formData,
                    veny_indvdl_permit_file_data: {
                        type: file.type,
                        name: file.name,
                        size: file.size,
                        originalFile: file
                    },
                    veny_indvdl_permit_file_url: response.indvdl_permit_file_url || response.image_url || '',
                    veny_indvdl_permit_file: response.indvdl_permit_file || response.id || 1
                });
                return true;
            }
            return false;
        } catch (error) {
            console.error('Fájl feldolgozási hiba:', error);
            return false;
        }
    };

    const handleFileChange = async (e) => {
        const file = e.target.files[0];
        if (file) {
            await processFile(file);
        }
    };

    const handleCameraCapture = async (e) => {
        const file = e.target.files[0];
        if (file) {
            setUploadLoading(true);
            try {
                
                await processFile(file);
            } catch (error) {
                console.error("Kamera feltöltés hiba:", error);
            } finally {
                
                setUploadLoading(false);
                setShowImageOptions(false);
            }
        }
    };

    const handleGalleryUpload = async (e) => {
        const file = e.target.files[0];
        if (file) {
            setUploadLoading(true);
            try {
                
                await processFile(file);
            } catch (error) {
                console.error("Galéria feltöltés hiba:", error);
            } finally {
                
                setUploadLoading(false);
                setShowImageOptions(false);
            }
        }
    };

    const onDrop = useCallback(acceptedFiles => {
        if (acceptedFiles.length > 0) {
            setUploadLoading(true);
            processFile(acceptedFiles[0]).finally(() => {
                setUploadLoading(false);
            });
        }
    }, []);

    const { getRootProps, getInputProps, isDragActive } = useDropzone({ 
        onDrop,
        accept: {
            'image/jpeg': ['.jpg', '.jpeg'],
            'image/png': ['.png'],
            'application/pdf': ['.pdf']
        },
        maxFiles: 1
    });

    const handleSubmit = () => {

		const isPermitNumberValid = formData.veny_indvdl_permit_nr && formData.veny_indvdl_permit_nr.length === 10;

		const isDocumentUploaded = formData.veny_indvdl_permit_file !== 1 && !!formData.veny_indvdl_permit_file_url;

		if (!isPermitNumberValid && !isDocumentUploaded) {
            setShowModal(true);
            return;
        }

        updateAktualisVeny({
            veny_indvdl_permit_nr: formData.veny_indvdl_permit_nr ? String(formData.veny_indvdl_permit_nr) : null,
			veny_indvdl_permit_file: formData.veny_indvdl_permit_file,
            veny_indvdl_permit_file_url: formData.veny_indvdl_permit_file_url || null,
        });
        if (order.hmeliorder?.hmeliorder_depot_prefix === "BETÉT") {
            navigate("/BetetTartozek");
        } else {
            navigate("/Mennyiseg");
        }
    };

    const handleModalYes = () => {
        updateOrder((prev) => {
            const venyek = [...prev.venyek];
            venyek[prev.aktivVenyIndex] = {
                ...venyek[prev.venyek[prev.aktivVenyIndex]],
                veny_indvdl_permit_nr: null,
                veny_indvdl_permit_file: 1,
                veny_indvdl_permit_file_url: null,
            };

            return {
                ...prev,
                venyek,
                hmeliorder: {
                    ...prev.hmeliorder,
                    hmeliorder_specaidtype: 1,
                    hmeliorder_specaidtype_national: "Normatív",
                },
            };
        });

        setShowModal(false);

        if (order.hmeliorder?.hmeliorder_depot_prefix === "BETÉT") {
            navigate("/BetetTartozek");
        } else {
            navigate("/Mennyiseg");
        }
    };

    const handleModalNo = () => {
        setShowModal(false);
    };

    const handleBackClick = () => {
        navigate("/AdatVenyes");
    };

    const handleRemoveFile = () => {
        
        if (formData.veny_indvdl_permit_file === 1) {
            setFormData(prev => ({
                ...prev,
                veny_indvdl_permit_file_data: null,
                veny_indvdl_permit_file_url: null,
                veny_indvdl_permit_file: 1,
            }));
            
            
            if (formData.veny_indvdl_permit_file_data?.originalFile) {
                try {
                    URL.revokeObjectURL(URL.createObjectURL(formData.veny_indvdl_permit_file_data.originalFile));
                } catch (e) {
                    console.log('Blob felszabadítási hiba:', e);
                }
            }
            return;
        }
        
        
        setDeleteFileModal({
            show: true,
            loading: false
        });
    };

    const confirmFileDelete = async () => {
        try {
            setDeleteFileModal(prev => ({...prev, loading: true}));
            
            if (formData.veny_indvdl_permit_file && formData.veny_indvdl_permit_file !== 1) {
                const deleteData = {
                    hmeliorder_szam: order.hmeliorder?.hmeliorder_szam,
                    veny_szam: order.venyek[order.aktivVenyIndex]?.veny_szam || 1,
                    file_id: formData.veny_indvdl_permit_file,
                    attachment_type: 'egyedi_kerelem'
                };
                
                const response = await dataService.deleteImage(deleteData);
                
                if (response.data?.status !== 'ok') {
                    throw new Error(response.data?.message || 'Hiba történt a dokumentum törlésekor');
                }
            }

            
            setFormData(prev => ({
                ...prev,
                veny_indvdl_permit_file_data: null,
                veny_indvdl_permit_file_url: null,
                veny_indvdl_permit_file: 1,
            }));
            
            
            if (formData.veny_indvdl_permit_file_data?.originalFile) {
                try {
                    URL.revokeObjectURL(URL.createObjectURL(formData.veny_indvdl_permit_file_data.originalFile));
                } catch (e) {
                    console.log('Blob felszabadítási hiba:', e);
                }
            }
            
            setDeleteFileModal({
                show: false,
                loading: false
            });
            
        } catch (error) {
            console.error('Dokumentum törlési hiba:', error);
            setErrorModal({
                show: true,
                title: "Törlési hiba",
                message: `Hiba történt a dokumentum törlésekor, kérem, próbálja meg újra! <br /> ${error.message}`
            });
            
            setDeleteFileModal(prev => ({...prev, loading: false}));
        }
    };

    const cancelFileDelete = () => {
        setDeleteFileModal({
            show: false,
            loading: false
        });
    };

    const closeErrorModal = () => {
        setErrorModal({
            show: false,
            title: "",
            message: ""
        });
    };

    useEffect(() => {
        const fetchImage = async (fileId) => {
            try {
                const imageData = {
                    hmeliorder_szam: order.hmeliorder?.hmeliorder_szam,
                    veny_szam: order.venyek[order.aktivVenyIndex]?.veny_szam || 1,
                    file_id: fileId,
                    attachment_type: 'egyedi_kerelem'
                };
                
                const response = await dataService.getImage(imageData);
                
                if (response.data?.status === 'ok') {
                    const {
                        image,              // base64 kódolású képadat 
                        file_name,          // fájl neve
                        content_type,       // MIME típus (pl. image/jpeg)
                        file_ext,           // kiterjesztés
                        indvdl_permit_file, // file azonosító
                    } = response.data.data;

                    
                    const byteString = atob(image);
                    const ab = new ArrayBuffer(byteString.length);
                    const ia = new Uint8Array(ab);
                    
                    for (let i = 0; i < byteString.length; i++) {
                        ia[i] = byteString.charCodeAt(i);
                    }
                    
                    const blob = new Blob([ab], { type: content_type });
                    const file = new File([blob], file_name || `document.${file_ext || 'jpg'}`, { type: content_type });
                    
                    setFormData(prev => ({
                        ...prev,
                        veny_indvdl_permit_file_data: {
                            type: content_type,
                            name: file_name || "Korábban feltöltött dokumentum",
                            size: blob.size,
                            originalFile: file
                        },
                        veny_indvdl_permit_file: indvdl_permit_file || fileId,
                        veny_indvdl_permit_file_url: `data:${content_type};base64,${image}`
                    }));
                }
            } catch (error) {
                console.error("Kép lekérési hiba:", error);
                setErrorModal({
                    show: true,
                    title: "Dokumentum betöltési hiba",
                    message: "A korábban feltöltött dokumentum betöltése sikertelen volt. Kérjük, próbálja meg újra!"
                });
            }
        };

        const aktVeny = order.venyek[order.aktivVenyIndex] || {};
        
        
        setFormData({
            veny_indvdl_permit_nr: aktVeny.veny_indvdl_permit_nr ? String(aktVeny.veny_indvdl_permit_nr) : "",
            veny_indvdl_permit_file: aktVeny.veny_indvdl_permit_file || 1,
            veny_indvdl_permit_file_data: null,
            veny_indvdl_permit_file_url: aktVeny.veny_indvdl_permit_file_url || null,
        });

        if (aktVeny.veny_indvdl_permit_file && aktVeny.veny_indvdl_permit_file !== 1) {
            fetchImage(aktVeny.veny_indvdl_permit_file);
        }
    }, [order.aktivVenyIndex, order.venyek, order.hmeliorder?.hmeliorder_szam]);

    return (
        <TablerLayout title="Egyedi kérelem adatok">
            <div className="row justify-content-center" style={{ filter: showModal || errorModal.show || deleteFileModal.show ? "blur(3px)" : "none" }}>
                <div className="col-md-10 mb-4">

                    {/* Develop gombok */}
                    {process.env.NODE_ENV === 'development' && (
                        <div className="d-flex gap-2 flex-wrap mt-2 mt-md-0">
                            <button
                                type="button"
                                className="btn btn-warning btn-sm"
                                onClick={() => setIsMobile(!isMobile)}
                            >
                                🧪 Észlelt eszköz típusa: {isMobile ? 'Mobil' : 'Desktop'}
                            </button>
                            
                        </div>
                    )}
                    
                    <div className="container-xl">
                        <div style={{ textAlign: "right", fontWeight: 500, fontSize: "1.1rem", marginBottom: 8 }}>
                            {order.aktivVenyIndex + 1} / {order.venyek.length}. vény
                        </div>
                    </div>
                    <div className="card-body">
                        <div className="mb-3">
                            <label className="form-label">
                                Egyedi kérelem száma: <span className="text-danger">*</span>
                            </label>
                            <input 
                                type="text" 
                                className="form-control" 
                                name="veny_indvdl_permit_nr" 
                                value={formData.veny_indvdl_permit_nr} 
                                onChange={handleInputChange} 
                                required 
                                placeholder="10 karakteres kérelem szám"
                            />
                        </div>
                        
                        <div className="mb-3">
                            <label className="form-label">
                                Egyedi kérelemről dokumentum csatolása: <span className="text-danger">*</span>
                            </label>
                            
                            {/* Feltöltött kép/dokumentum előnézet */}
                            {formData.veny_indvdl_permit_file_data && (
                                <div className="card mb-3 p-3 position-relative">
                                    <div className="position-absolute top-0 end-0">
                                        <button 
                                            className="btn btn-sm btn-outline-danger rounded-circle" 
                                            onClick={handleRemoveFile}
                                            type="button"
                                            disabled={uploadLoading || deleteFileModal.loading}
                                        >
                                            <IconX size={18} />
                                        </button>
                                    </div>


                                    {process.env.NODE_ENV === 'development' && (
                                        <div className="bg-light p-2 mb-2 small">
                                            <div>Típus: {formData.veny_indvdl_permit_file_data.type}</div>
                                            <div>URL?: {formData.veny_indvdl_permit_file_url ? 'Van' : 'Nincs'}</div>
                                            <div>Méret: {formData.veny_indvdl_permit_file_data.size}</div>
                                        </div>
                                    )}
        
                                    {formData.veny_indvdl_permit_file_data.type && formData.veny_indvdl_permit_file_data.type.includes('image') && 
                                        formData.veny_indvdl_permit_file_url ? (
                                            
                                            // Kép előnézet
                                            formData.veny_indvdl_permit_file_data.originalFile ? (
                                                <div className="text-center">
                                                    <img 
                                                    src={URL.createObjectURL(formData.veny_indvdl_permit_file_data.originalFile)} 
                                                    alt="Előnézet" 
                                                    className="img-thumbnail mb-2"
                                                    style={{ maxWidth: '200px', maxHeight: '200px' }}
                                                />
                                                </div>
                                            ) : (
                                                <div className="text-center">
                                                    <img 
                                                        src={formData.veny_indvdl_permit_file_url} 
                                                        alt="Előnézet (r)" 
                                                        className="img-thumbnail mb-2"
                                                        style={{ maxWidth: '200px', maxHeight: '200px' }}
                                                    />
                                                </div>
                                            )
                                        ) : (
                                            // PDF vagy nem kép dokumentum
                                            <div className="d-flex align-items-center justify-content-center mb-2 py-4">
                                                <IconFile size={40} className="me-2 text-primary" />
                                                <span className="fs-5">PDF dokumentum</span>
                                            </div>
                                        )}

                                    <div className="small text-muted">
                                        {formData.veny_indvdl_permit_file_data.name || "Feltöltött fájl"} 
                                        {formData.veny_indvdl_permit_file_data.size && `(${Math.round(formData.veny_indvdl_permit_file_data.size / 1024)} KB)`}
                                        {uploadLoading && <span className="text-warning ms-2"> - Feltöltés...</span>}
                                    </div>
                                </div>
                            )}

                            {/* Desktop - Dropzone */}
                            {!isMobile && !formData.veny_indvdl_permit_file_data && (
                                <div 
                                    {...getRootProps()} 
                                    className={`dropzone border border-2 rounded-3 p-5 text-center my-3 ${isDragActive ? 'border-primary bg-light' : ''}`}
                                    style={{ 
                                        borderStyle: isDragActive ? 'solid' : 'dashed',
                                        cursor: 'pointer',
                                        minHeight: '200px',
                                        display: 'flex',
                                        flexDirection: 'column',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        backgroundColor: isDragActive ? '#f8f9fa' : 'transparent',
                                    }}
                                >
                                    <input {...getInputProps()} />
                                    <IconUpload size={48} className="mb-3 text-primary" />
                                    <p className="mb-2 fs-5 fw-bold">Húzza ide a fájlt vagy kattintson a feltöltéshez</p>
                                    <p className="text-muted mb-0">
                                        Elfogadott formátumok: JPG, PNG, PDF (max. 5MB)
                                    </p>
                                </div>
                            )}

                            {/* Mobil - Kamera vagy galéria választó gomb */}
                            {isMobile && !formData.veny_indvdl_permit_file_data && (
                                <div className="d-grid gap-2">
                                    <button
                                        type="button"
                                        className={`btn ${uploadLoading ? 'btn-primary' : 'btn-outline-primary'}`}
                                        onClick={() => !uploadLoading && setShowImageOptions(true)}
                                        disabled={uploadLoading}
                                    >
                                        {uploadLoading ? (
                                            <>
                                                <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                                <span>Feltöltés folyamatban...</span>
                                            </>
                                        ) : (
                                            <>
                                                <IconPhoto className="me-2" size={20} />
                                                Dokumentum csatolása
                                            </>
                                        )}
                                    </button>
                                    {uploadLoading && (
                                        <div className="small text-center text-primary mt-1">
                                            Kérjük várjon, amíg a feltöltés befejeződik!
                                        </div>
                                    )}
                                </div>
                            )}

                            {/* Desktop - Hagyományos file input (alternatívaként, ha már van feltöltött fájl) */}
                            {!isMobile && formData.veny_indvdl_permit_file_data && (
                                <div className="mt-3">
                                    <button
                                        type="button"
                                        className="btn btn-outline-primary"
                                        onClick={() => document.getElementById('desktop-file-input').click()}
                                        disabled={uploadLoading}
                                    >
                                        <IconPhoto className="me-2" size={20} />
                                        Másik dokumentum kiválasztása
                                    </button>
                                    <input 
                                        type="file" 
                                        className="d-none" 
                                        name="desktop_file" 
                                        accept=".jpg,.jpeg,.png,.pdf" 
                                        onChange={handleFileChange}
                                        id="desktop-file-input"
                                    />
                                </div>
                            )}

                            {/* Mobil - Rejtett inputok */}
                            <input 
                                type="file" 
                                className="d-none" 
                                name="gallery_file" 
                                accept="image/*,.pdf" 
                                onChange={handleGalleryUpload}
                                id="gallery-input"
                            />
                            <input 
                                type="file" 
                                className="d-none" 
                                accept="image/*" 
                                capture="environment"
                                onChange={handleCameraCapture}
                                id="camera-input"
                            />
                        </div>
                    </div>
                </div>
                <div className="d-flex justify-content-between mt-4">
                    <StepperNavButton
						side="left"
						label="Vissza"
						onClick={handleBackClick}
					/>
                    <StepperNavButton 
                        side="right" 
                        label="Tovább" 
                        onClick={handleSubmit}
                        disabled={uploadLoading}
                    />
                </div>
            </div>

            {/* Kép opciók modal (csak mobilon) */}
            <Modal 
                isOpen={showImageOptions} 
                onClose={() => !uploadLoading && setShowImageOptions(false)}  
                title="Dokumentum hozzáadása"
                type="info"
                showCancel={!uploadLoading}
                cancelText="Mégsem"
                closeOnEsc={!uploadLoading}
                closeOnOutsideClick={!uploadLoading}
            >
                <div className="d-grid gap-3">
                    <button
                        className="btn btn-primary py-3"
                        onClick={() => document.getElementById('camera-input').click()}
                        disabled={uploadLoading}
                    >
                        {uploadLoading ? (
                            <>
                                <span className="spinner-border spinner-border-sm me-2" role="status"></span>
                                Folyamatban...
                            </>
                        ) : (
                            <>
                                <IconCamera className="me-2" size={24} />
                                Fotó készítése
                            </>
                        )}
                    </button>
                    <button
                        className="btn btn-outline-primary py-3"
                        onClick={() => document.getElementById('gallery-input').click()}
                        disabled={uploadLoading}
                    >
                        {uploadLoading ? (
                            <>
                                <span className="spinner-border spinner-border-sm me-2" role="status"></span>
                                Folyamatban...
                            </>
                        ) : (
                            <>
                                <IconPhoto className="me-2" size={24} />
                                Dokumentum kiválasztása
                            </>
                        )}
                    </button>
                </div>
                {uploadLoading && (
                    <div className="alert alert-info mt-3">
                        <div className="d-flex align-items-center mb-2">
                            <div className="spinner-border text-primary me-3" role="status">
                                <span className="visually-hidden">Feltöltés...</span>
                            </div>
                            <div className="fw-bold">Dokumentum feltöltése folyamatban...</div>
                        </div>
                        <div className="small mt-1">Kérjük, várjon, amíg a feltöltés befejeződik. Ne zárja be az alkalmazást!</div>
                    </div>
                )}
                <div className="mt-3 text-center text-muted small">
                    Elfogadott formátumok: JPG, PNG, PDF (max. 5MB)
                </div>
            </Modal>

            {/* Eredeti modal */}
            <Modal 
                isOpen={showModal} 
                onClose={handleModalNo} 
                onConfirm={handleModalYes} 
                title="Hiányzó információk" 
                type="warning" 
                confirmText="Igen" 
                secondaryText="Nem" 
                confirmClass="btn btn-primary" 
                secondaryClass="btn btn-danger" 
                showSecondary={true} 
                showCancel={true} 
                icon={<IconAlertSmall size={70} stroke={2} className="text-warning" />}
            >
                <h4>
					Az alábbiak közül legalább az egyiket meg kell adnia:
				</h4>
				<ul className="text-start fs-5 mb-3">
					<li>Pontos kérelem szám (10 karakter)</li>
					<li>Feltöltött dokumentum a kérelemről</li>
				</ul>
                <h5>Kívánja normatív vényként rögzíteni?</h5>
            </Modal>

            {/* Új hibaüzenet modal */}
            <Modal 
                isOpen={errorModal.show} 
                onClose={closeErrorModal} 
                onConfirm={closeErrorModal} 
                title={errorModal.title}
                type="danger" 
                confirmText="Rendben" 
                confirmClass="btn btn-primary" 
                showSecondary={false} 
                showCancel={false} 
                icon={<IconAlertTriangle size={70} stroke={2} className="text-danger" />}
            >
                <p className="fs-5" dangerouslySetInnerHTML={{ __html: errorModal.message }}></p>
            </Modal>

            {/* Dokumentum törlés megerősítő modal */}
            <Modal 
                isOpen={deleteFileModal.show} 
                onClose={cancelFileDelete} 
                onConfirm={confirmFileDelete} 
                title="Dokumentum törlése" 
                type="warning" 
                confirmText="Törlés" 
                secondaryText="Mégsem" 
                confirmClass="btn btn-danger" 
                secondaryClass="btn btn-outline-secondary" 
                showSecondary={true} 
                showCancel={false} 
                icon={<IconAlertTriangle size={70} stroke={2} className="text-warning" />}
                confirmDisabled={deleteFileModal.loading}
            >
                <h4 className="mb-3">Biztosan törölni szeretné ezt a dokumentumot?</h4>
                <p className="fs-5">
                    A törölt dokumentum nem állítható vissza.
                    {deleteFileModal.loading && (
                        <span className="d-block mt-2">
                            <div className="spinner-border spinner-border-sm text-primary me-2" role="status">
                                <span className="visually-hidden">Loading...</span>
                            </div>
                            Törlés folyamatban...
                        </span>
                    )}
                </p>
            </Modal>

        </TablerLayout>
    );
};

export default EgyediKerdes;
